import createVueApp from '@phoenix/createVueApp';
import CpraForm from '@phoenix/components/form/CpraForm.vue';

const app = createVueApp({}, true);
app.component('CpraForm', CpraForm);
app.mount('#phoenix-cpra-form');
